export default "__VITE_ASSET__grTvvvKD__"